export const projectBookingKeys = {
  all: () => ['projectBookings'] as const,
  list: (projectContainerId: number | undefined, projectHotelId?: number) =>
    ['projectBookings', projectContainerId, projectHotelId] as const,
  cards: (projectContainerId: number | undefined) => ['projectBookings', 'cards', projectContainerId] as const,
  availablePayments: (projectContainerId: number | undefined) =>
    ['projectBookings', 'availablePayments', projectContainerId] as const
};
